import React, { useState } from 'react';
import { Lock, User, AlertCircle, Waves } from 'lucide-react';
import axios from 'axios';
import './Login.css';

const API_BASE = process.env.NODE_ENV === 'development' 
  ? 'http://localhost:5001/api' 
  : '/api';

const Login = ({ onLogin }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [showIconLogo, setShowIconLogo] = useState(false);

  // Valid user credentials
  const VALID_USERS = [
    { username: 'Collin', password: 'iloveCENTURION2025!', isAdmin: true },
    { username: 'CenturionAdmin', password: 'Centurion2025!', isAdmin: true }
  ];
  
  // Official Centurion logo from centurionboats.com
  const logoUrl = '/centurion-logo.svg';

  // Get admin token from server for admin users
  const getAdminToken = async () => {
    try {
      const response = await axios.post(`${API_BASE}/admin/login`, {
        email: 'admin@centurion.com',
        password: 'centurion2025'
      });
      if (response.data.token) {
        localStorage.setItem('adminToken', response.data.token);
        console.log('✅ Admin token obtained automatically');
      }
    } catch (err) {
      console.warn('Could not get admin token:', err.message);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    const validUser = VALID_USERS.find(
      user => user.username === username && user.password === password
    );
    
    if (validUser) {
      // If admin user, get admin token automatically
      if (validUser.isAdmin) {
        await getAdminToken();
      }
      
      // Store auth in localStorage with admin status
      localStorage.setItem('centurion_auth', JSON.stringify({
        username: username,
        isAdmin: validUser.isAdmin,
        timestamp: Date.now()
      }));
      onLogin(username, validUser.isAdmin);
    } else {
      setError('Invalid username or password');
      setPassword('');
    }
    setIsLoading(false);
  };

  return (
    <div className="login-container">
      <div className="login-background">
        <div className="wave wave-1"></div>
        <div className="wave wave-2"></div>
        <div className="wave wave-3"></div>
      </div>
      
      <div className="login-card">
        <div className="login-header">
          <div className="logo-container">
            {!showIconLogo ? (
              <img 
                src={logoUrl}
                alt="Centurion Boats"
                className="login-logo"
                onError={(e) => {
                  // Try local fallback first, then icon
                  if (e.target.src !== '/centurion-logo.svg') {
                    e.target.src = '/centurion-logo.svg';
                  } else {
                    setShowIconLogo(true);
                  }
                }}
              />
            ) : (
              <>
                <Waves className="logo-icon" size={48} />
                <h1 className="logo-text">CENTURION</h1>
              </>
            )}
          </div>
          <h2 className="login-subtitle">Boat Inventory System</h2>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label className="form-label">
              <User size={18} />
              Username
            </label>
            <input
              type="text"
              className="form-input"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Enter your username"
              required
              autoFocus
            />
          </div>

          <div className="form-group">
            <label className="form-label">
              <Lock size={18} />
              Password
            </label>
            <input
              type="password"
              className="form-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter your password"
              required
            />
          </div>

          {error && (
            <div className="error-message">
              <AlertCircle size={16} />
              {error}
            </div>
          )}

          <button 
            type="submit" 
            className={`login-button ${isLoading ? 'loading' : ''}`}
            disabled={isLoading}
          >
            {isLoading ? (
              <>
                <span className="spinner"></span>
                Logging in...
              </>
            ) : (
              <>
                <Lock size={18} />
                Login to Dashboard
              </>
            )}
          </button>
        </form>

        <div className="login-footer">
          <p>© 2025 Centurion Boats</p>
          <p className="security-notice">
            <Lock size={14} />
            Secure Access Portal
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;
